<script lang="ts">
import Vue from 'vue'
import GlobalLogin from "@global/global-elements/global-login/global-login.vue";
import GlobalButton from "@global/global-elements/global-button/global-button.vue";

export default Vue.extend({
    name: "MediaGalleryLogin",
    components: {GlobalButton, GlobalLogin}
})
</script>

<template>
    <div class="container">
        <div class="row">
            <div class="ce-wrapper">
                <div class="ce-text ce-bodytext">
                    <GlobalLogin>
                        <p v-html="$t('mediaGallery.login')"></p>
                    </GlobalLogin>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
